<template>
  <div class="guide-container">
    <div class="guide-header">
      <h2 class="title">이용가이드</h2>
      <create-guide-modal @submitted="refreshGuides" />
    </div>

    <hr class="divider"/>

    <ul class="guide-list">
      <guide-item
        v-for="item in guides"
        :key="item.id"
        :guide="item"
        @edit="editGuide"
      />
    </ul>

    <div class="pagination">
      <button @click="loadMore" :disabled="meta && meta.last">더보기</button>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRouter } from 'vue-router';
import * as guideApi from '@/api/guide';
import GuideItem from './GuideItem.vue';
import CreateGuideModal from './CreateGuideModal.vue';

function formatDate(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export default {
  components: {
    GuideItem,
    CreateGuideModal,
  },
  setup() {
    const guides = ref([]);
    const meta = ref(null);
    const router = useRouter();

    const fetchGuides = async (id = null) => {
      try {
        const res = await guideApi.getGuide(id);
        const responseData = res.data.response;
        const formattedGuides = responseData.guides.map(g => ({ ...g, date: formatDate(g.createdAt) }));

        if (id) {
          guides.value.push(...formattedGuides);
        } else {
          guides.value = formattedGuides;
        }
        meta.value = responseData.meta;
      } catch (error) {
        console.error("가이드 목록을 불러오는 데 실패했습니다.", error);
      }
    };

    const refreshGuides = () => {
      fetchGuides();
    };

    const loadMore = () => {
      if (meta.value && !meta.value.last) {
        const lastId = guides.value[guides.value.length - 1]?.id;
        if (lastId) {
          fetchGuides(lastId);
        }
      }
    };

    const editGuide = (id) => {
      router.push({
        path: "/guide/edit",
        state: { data: id },
      });
    };

    onMounted(() => {
      fetchGuides();
    });

    return {
      guides,
      meta,
      refreshGuides,
      loadMore,
      editGuide,
    };
  },
};
</script>

<style scoped>
.guide-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 0px 32px;
  gap: 16px;
  width: 100%;
  background: #263238;
  border-radius: 20px;
}

.guide-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px;
  width: 100%;
  height: 34px;
  align-self: stretch;
}

.title {
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  letter-spacing: -0.3px;
  color: #ECEFF1;
}

.divider {
  width: 100%;
  border: 1px solid #90A4AE;
}

.guide-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;
}

.pagination {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20px 24px 0px;
  width: 100%;
  align-self: stretch;
}
</style>